module.exports = __webpack_public_path__ + "static/media/orange-checkbox.6076285a.svg";